import { Button } from 'components/ui'
import { useCartModal } from 'hooks'
import type { FC } from 'react'
import { CartEmptyProps } from '.'
import s from './cart-empty.module.css'

const CartEmpty: FC<CartEmptyProps> = ({ fromWidget = true, label = 'Volte as compras', isSubscriptionCart = false, isExpCart = false }) => {
  const { toggleCartModal } = useCartModal()

  return (
    <div className={s.root}>
      {isSubscriptionCart && <div className={s.title}>Seu carrinho de assinaturas está vazio</div>}
      {isExpCart && <div className={s.title}>Seu carrinho de assinaturas está vazio</div>}
      {!isSubscriptionCart && <div className={s.title}>Seu carrinho de compras está vazio</div>}
      <div className={s.content}>
        {fromWidget ? <Button onClick={toggleCartModal}>{label}</Button> : <Button href="/">{label}</Button>}
      </div>
    </div>
  )
}

export default CartEmpty
